import { Typography } from '@mui/material';
import { useTextMessageStyles } from './textMessage.styles';
import { TextMessageProps } from './textMessage.types';

const TextMessage = ({ isMessageOfUser, message, hasError, isSending }: TextMessageProps) => {
  const { classes: styles } = useTextMessageStyles({ isMessageOfUser, hasError, isSending });

  return (
    <Typography className={styles.message} variant={isMessageOfUser ? 'subtitle1' : 'body1'}>
      {message}
    </Typography>
  );
};

export default TextMessage;
